<div class="d-flex flex-column justify-content-between dea-radius dea-shadow w-100 home-statistic-counter-zoom bg-white"
  style="height: 95px" [ngClass]="{'pointer': hasLinkAction, 'home-statistic-counter-zoom': hasLinkAction }"
  (click)="onClick()">
  <div class="counter-label mt-2" style="margin-bottom: -8px;">{{label}}</div>
  <div class="counter-number" [appCountUp]=value></div>
</div>
